<mat-form-field
  class="me-2"
  [ngClass]="{
    'alert-select': field.varName === 'AlertIDs' || field.varName === 'AlertID',
  }"
>
  <mat-label>{{ field.label }}</mat-label>
  <mat-select
    multiple
    (selectionChange)="selected($event)"
    [formControl]="filterForm.controls[groupKey].controls[field.varName]"
  >
    @for (opt of field.options; track opt.value) {
      <mat-option value="{{ opt.value }}">
        {{ opt.display }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
